import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2278dae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-tool" }

import {
  Reset,
  ZoomIn,
  ZoomOut,
  // ViewSwitch,
  Clear,
  BaseViewChaneg,
  Distance,
  Measurement
} from "./components"

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Reset)),
    _createVNode(_unref(ZoomIn)),
    _createVNode(_unref(ZoomOut)),
    _createVNode(_unref(Distance)),
    _createVNode(_unref(Measurement)),
    _createVNode(_unref(Clear)),
    _createVNode(_unref(BaseViewChaneg))
  ]))
}
}

})